export default "__VITE_ASSET__2182f26f__"